import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/images`;

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axios.post(API_BASE_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deleteImage = async (imageId) => {
  const response = await axios.delete(`${API_BASE_URL}/${imageId}`);
  return response.data;
};

export const getImageUrl = (imageId) => {
  return `${API_BASE_URL}/${imageId}`;
}; 
